const initTabbedTiles = () => {
  const tabbedTilesEls = document.querySelectorAll('[data-tabbed-tiles-button]');
  if (!tabbedTilesEls.length) return;

  tabbedTilesEls.forEach(button => {
    button.addEventListener('click', () => {
      const blockGroup = button.dataset.blockGroup;
      const contentEls = document.querySelectorAll('[data-tabbed-tiles-content]');
      contentEls.forEach(content => {
        content.classList.toggle('!hidden', content.dataset.blockGroup !== blockGroup);
        tabbedTilesEls.forEach(btn => {
          btn.disabled = false;
        });
        button.disabled = true;
      });
    });
  });
};

export default initTabbedTiles;